import { render, staticRenderFns } from "./info_loading.vue?vue&type=template&id=b2049e8e&scoped=true&lang=pug&"
import script from "./info_loading.vue?vue&type=script&lang=js&"
export * from "./info_loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2049e8e",
  null
  
)

export default component.exports